import Vue from 'vue'
import { Plugin } from '@nuxt/types'

import raygunClientWrapper from '~/utils/raygunClientWrapper'

const raygunClient: Plugin = ({ store, $config }, inject) => {
  const raygun = {
    activate: () => {
      const headerScript = document.createElement('script')
      headerScript.textContent = `!function(a,b,c,d,e,f,g,h){a.RaygunObject=e,a[e]=a[e]||function(){
        (a[e].o=a[e].o||[]).push(arguments)},f=b.createElement(c),g=b.getElementsByTagName(c)[0],
        f.async=1,f.src=d,g.parentNode.insertBefore(f,g),h=a.onerror,a.onerror=function(b,c,d,f,g){
        h&&h(b,c,d,f,g),g||(g=new Error(b)),a[e].q=a[e].q||[],a[e].q.push({
        e:g})}}(window,document,"script","//cdn.raygun.io/raygun4js/raygun.min.js","rg4js")`

      const userMonitoring = {
        identifier: store.getters.currentUser ? store.getters.currentUser.id : 'anonymous',
        isAnonymous: Boolean(store.getters.currentUser),
      }

      const bodyScript = document.createElement('script')
      bodyScript.textContent = `
        rg4js('enableCrashReporting', true);
        rg4js('apiKey', "${$config.RAYGUN_API_KEY}");
        rg4js('setUser', ${JSON.stringify(userMonitoring)});
        rg4js('setVersion', "${$config.APP_VERSION}");
      `
      const head = document.getElementsByTagName('head')[0]
      head.appendChild(headerScript)
      const body = document.getElementsByTagName('body')[0]
      body.appendChild(bodyScript)

      const oldOnError = Vue.config.errorHandler
      Vue.config.errorHandler = function (err, vm, info) {
        window.rg4js('send', {
            error: err,
            customData: [{ info }],
            tags: ['client']
        })
        if (typeof oldOnError === 'function') {
          oldOnError.call(Vue, err, vm, info)
        }
      }

      inject('raygun', raygunClientWrapper)
    }
  }
  if ($config.RAYGUN_API_KEY) {
    raygun.activate()
  }
}

export default raygunClient
